"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const table = require("./table");
const selector = require("./selector/index");
const HOC_1 = require("./HOC");
const react_rxk_1 = require("react-rxk");
const spinner_1 = require("./spinner");
const keautils_1 = require("keautils");
/**Un selector de pagina */
class PageSelector extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleOnChange = (value) => {
            if (!this.props.onValueChanged)
                return;
            this.props.onValueChanged(value);
        };
    }
    get Items() {
        var ret = [];
        var paginas = keautils_1.range(0, this.props.count).map(x => ({ value: x, label: x + 1, tooltip: "página " + (x + 1) }));
        return paginas;
    }
    render() {
        return (React.createElement(selector.PaginatedButtonSelector, { items: this.Items, value: this.props.selected, onChange: this.handleOnChange }));
    }
}
exports.PageSelector = PageSelector;
const commonPageSizes = [10, 15, 30, 50, 100, 200, 500, 1000, 2000, 5000, 10000];
/**Una tabla paginada, el usuario puede cambiar la pagina actual.
 * Establezca los elementos tr de la tabla como los hijos de este componente
*/
class SyncPaginatedTable extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleSelectedPageChange = (page) => {
            if (this.props.onChange) {
                this.props.onChange(Object.assign({}, this.props.value, { selectedPage: page }));
            }
        };
        this.handlePageSizeChange = (size) => {
            if (this.props.onChange) {
                this.props.onChange(Object.assign({}, this.props.value, { selectedPageSize: size }));
            }
        };
    }
    /**Cantidad total de elementos */
    get ItemsCount() {
        return this.Items.length;
    }
    /**Cantidad de páginas */
    get PageCount() {
        return Math.ceil(this.ItemsCount / this.PageSize);
    }
    /**Tamaño de la página */
    get PageSize() {
        return this.props.value.selectedPageSize;
    }
    /**Todos los elementos */
    get Items() {
        return (this.props.items || []);
    }
    /**Maxima pagina que se puede seleccionar */
    get MaxPage() {
        return Math.max(this.PageCount - 1, 0);
    }
    /**Pagina que se debe de mostrar como la seleccionada */
    get EffectiveSelected() {
        return Math.min(this.selectedPage, this.MaxPage);
    }
    get selectedPage() {
        return this.props.value.selectedPage;
    }
    get PageItems() {
        const selectedPage = this.EffectiveSelected;
        return (this.Items
            .slice(selectedPage * this.PageSize, (selectedPage + 1) * this.PageSize)
            .map(x => (typeof x == "function") ? x() : x));
    }
    /**Tamaños de página disponibles para que el usuario seleccione */
    get PageSizes() {
        const count = this.ItemsCount;
        var ret = commonPageSizes.filter(x => x < count);
        ret.push(count);
        return ret;
    }
    /**Determina si se deben de mostrar los controles del paginador */
    get ShowPageControls() {
        const minPageSize = commonPageSizes[0];
        return this.Items.length > minPageSize;
    }
    render() {
        //TODO: Usar aqui el PageSelector
        return (React.createElement("div", null,
            React.createElement("span", null,
                this.ShowPageControls &&
                    React.createElement(PageSelector, { onValueChanged: this.handleSelectedPageChange, selected: this.EffectiveSelected, count: this.PageCount }),
                /**Selector del tamaño de la página*/
                this.ShowPageControls &&
                    React.createElement("div", { className: "pull-right" },
                        React.createElement(selector.ButtonSelector, { items: this.PageSizes.map(x => ({ value: x, label: x, tooltip: x + " elementos por página" })), value: this.props.value.selectedPageSize, onChange: this.handlePageSizeChange }))),
            React.createElement(table.Table, { header: this.props.header, items: this.PageItems })));
    }
}
const ControlledPaginatedTable = react_rxk_1.componentToRx(SyncPaginatedTable, spinner_1.Spinner);
exports.PaginatedTable = HOC_1.makeUncontrolledCookies("value", "onChange")(ControlledPaginatedTable);



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/pagination.js
// module id = 2245
// module chunks = 0